module.exports = __webpack_public_path__ + "public/images/netw-find-member-desktop.32e77729c0d0d411317b8bccc369b57f.jpg";